import { Box, LinearProgress, SxProps, Theme } from '@mui/material';
import { useMemo } from 'react';
import { useContractApprovalWorkflowListState } from 'shared/contexts/contract-approval-workflow-filter-context';
import { ContractReviewTable } from './tables/contract-review-table';
import { ContractReviewTableFilters } from './tables/contract-review-table-filters';
import { useContractReviewTableInstance } from './tables/contract-review-table-instance';

const mainContentStyles: SxProps<Theme> = {
  padding: 2,
};

const containerStyles: SxProps<Theme> = {
  paddingTop: 2,
};

export function ContractReview() {
  const {
    draftContracts,
    contractApprovalWorkflowTableState,
    setContractApprovalWorkflowTableState,
    isFetching,
    isLoading,
  } = useContractApprovalWorkflowListState();

  const draftContractData = draftContracts?.contracts;
  const contractReviewTableData = useMemo(
    () =>
      (draftContractData || []).map(draftContractData => ({
        id: draftContractData.id,
        customerName: draftContractData.customerName,
        brand: draftContractData.brand,
        originalDocumentName: draftContractData.originalDocumentName,
        modifiedBy: draftContractData.modifiedBy,
        modifiedDate: draftContractData.modifiedDate,
        approvedBy: draftContractData.approvedBy,
        approvedDate: draftContractData.approvedDate,
        status: draftContractData.status,
      })),
    [draftContractData]
  );

  const contractReviewTableInstance = useContractReviewTableInstance(
    contractReviewTableData,
    draftContracts?.totalCount || 0,
    contractApprovalWorkflowTableState.tableState
  );
  const loading = isFetching || isLoading;

  return (
    <>
      <Box sx={mainContentStyles}>
        <ContractReviewTableFilters contractReviewTableInstance={contractReviewTableInstance} />
        <Box sx={containerStyles}>
          {loading && <LinearProgress color='secondary' />}
          <ContractReviewTable
            instance={contractReviewTableInstance}
            setContractApprovalWorkflowTableState={setContractApprovalWorkflowTableState}
            totalCount={!!draftContracts?.totalCount ? draftContracts.totalCount : 0}
          />
        </Box>
      </Box>
    </>
  );
}
